import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('floatingResourceAddMenu');

    return {
        APPLICATION_LABEL: t('applicationLabel'),
        ASSET_LABEL: t('assetLabel'),
        BOUNDARY_LABEL: t('boundaryLabel'),
        CLIENT_LABEL: t('clientLabel'),
        FARM_LABEL: t('farmLabel'),
        FIELD_LABEL: t('fieldLabel'),
        IMPORT_LABEL: t('importLabel'),
        MEMBER_LABEL: t('memberLabel'),
        PRESCRIPTION_LABEL: t('prescriptionLabel')
    };
};

export default useTranslation;
